import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function MachineBooking() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [farmlandList, setFarmlandList] = useState([]);
    const [formData, setFormData] = useState({
        machine: "",
        booked_by: "",
        farmland: "",
        booking_date: "",
        start_date: "",
        end_date: "",
        quantity: "",
        total_amount: "",
        status: "PENDING",
        remarks: "",
        addedby: userName,
        ip_add: ipAddress,
    });
    const bookingStatus = [{
        id: "PENDING", name: "Pending",
    }, {
        id: "APPROVED", name: "Approved",
    }, {
        id: "REJECTED", name: "Rejected",
    }, {
        id: "ONGOING", name: "Ongoing",
    }, {
        id: "COMPLETED", name: "Completed",
    }, {
        id: "CANCELLED", name: "Cancelled",
    },];
    useEffect(() => {
        getMachine();
        getUsers();
        getFarmland();
        getMachineBooking();
    }, []);
    const getMachine = () => {
        axios
            .get(baseUrl + "machine/")
            .then((res) => {
                setMachineList(res.data);
            });
    };
    const getUsers = () => {
        axios
            .get(baseUrl + "user-profile/")
            .then((res) => {
                setUserList(res.data);
            });
    };
    const getFarmland = () => {
        axios
            .get(baseUrl + "farmland/")
            .then((res) => {
                setFarmlandList(res.data);
            });
    };
    const getMachineBooking = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine-booking/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machine Bookings.",
                });
            });
    };
    const calculateTotal = (data) => {
        if (!data.machine || !data.start_date || !data.end_date || !data.quantity) {
            return;
        }
        const machine = machineList.find(m => m.id === parseInt(data.machine));
        if (!machine) return;
        const rent = parseFloat(machine.rent_amount);
        const qty = parseFloat(data.quantity);
        const start = new Date(data.start_date);
        const end = new Date(data.end_date);
        let units = 1;
        switch (machine.rent_unit) {
            case "DAY":
                units = Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1);
                break;
            case "HOUR":
                units = Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60)));
                break;
            case "MONTH":
                units = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
                break;
            case "YEAR":
                units = end.getFullYear() - start.getFullYear() + 1;
                break;
            default:
                units = 1;
        }
        data.total_amount = (rent * qty * units).toFixed(2);
    };
    const handleChange = (e) => {
        const data = {
            ...formData, [e.target.name]: e.target.value
        };
        calculateTotal(data);
        setFormData(data);
    };
    const clearForm = () => {
        setFormData({
            machine: "",
            booked_by: "",
            farmland: "",
            booking_date: "",
            start_date: "",
            end_date: "",
            quantity: "",
            total_amount: "",
            status: "PENDING",
            remarks: "",
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveMachineBooking = () => {
        const data = new FormData();
        data.append("machine", formData.machine);
        data.append("booked_by", formData.booked_by);
        data.append("farmland", formData.farmland);
        data.append("booking_date", formData.booking_date);
        data.append("start_date", formData.start_date);
        data.append("end_date", formData.end_date);
        data.append("quantity", formData.quantity);
        data.append("total_amount", formData.total_amount);
        data.append("status", formData.status);
        data.append("remarks", formData.remarks);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine-booking/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine Booking saved successfully.",
                });
                clearForm();
                getMachineBooking();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine Booking.",
                });
            });
    };
    const deleteMachineBooking = (id) => {
        Swal.fire({
            title: "Delete Machine Booking?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(baseUrl + `delete-machine-booking/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine Booking deleted successfully.",
                        });
                        getMachineBooking();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine Booking.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "machine_name",
        headerName: "Machine",
        width: 180,
        renderCell: (params) => params.row.machine?.machine_name || ""
    }, {
        field: "booked_by_name",
        headerName: "Booked By",
        width: 180,
        renderCell: (params) => params.row.booked_by?.name || ""
    }, {
        field: "farmland_name",
        headerName: "Farmland",
        width: 180,
        renderCell: (params) => params.row.farmland?.land_name || ""
    }, {
        field: "booking_date", headerName: "Booking Date", width: 130,
    }, {
        field: "start_date", headerName: "Start Date", width: 130,
    }, {
        field: "end_date", headerName: "End Date", width: 130,
    }, {
        field: "quantity", headerName: "Quantity", width: 110,
    }, {
        field: "total_amount", headerName: "Amount", width: 120,
    }, {
        field: "status", headerName: "Status", width: 130,
    },
    {
            field: "action",
            headerName: "Action",
            width: 180,
            sortable: false,
            renderCell: (params) => (
                <>

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteMachineBooking(params.row.id)}
                    >
                        Delete
                    </button>

                </>
            )
        }
        ];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Booking
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4 mb-3">

                            <label>Machine</label>

                            <select
                                className="form-select"
                                name="machine"
                                value={formData.machine}
                                onChange={handleChange}
                            >
                                <option value="">Select Machine</option>

                                {machineList.map((item) => (<option key={item.id} value={item.id}>
                                    {item.machine_name}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Booked By</label>

                            <select
                                className="form-select"
                                name="booked_by"
                                value={formData.booked_by}
                                onChange={handleChange}
                            >
                                <option value="">Select User</option>

                                {userList.map((item) => (<option key={item.id} value={item.id}>
                                    {item.name}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Farmland</label>

                            <select
                                className="form-select"
                                name="farmland"
                                value={formData.farmland}
                                onChange={handleChange}
                            >
                                <option value="">Select Farmland</option>

                                {farmlandList.map((item) => (<option key={item.id} value={item.id}>
                                    {item.land_name}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Booking Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="booking_date"
                                value={formData.booking_date}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Start Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="start_date"
                                value={formData.start_date}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>End Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="end_date"
                                value={formData.end_date}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Quantity</label>

                            <input
                                type="number"
                                className="form-control"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Total Amount</label>

                            <input
                                type="number"
                                className="form-control"
                                name="total_amount"
                                value={formData.total_amount}

                                readOnly
                            />
                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                {bookingStatus.map((item) => (<option key={item.id} value={item.id}>
                                    {item.name}
                                </option>))}
                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachineBooking}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine Booking List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}

                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>);
}
export default MachineBooking;
